/* eslint-disable import/no-import-module-exports */
import * as Sentry from '@sentry/react';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware, { END } from 'redux-saga';

import { IS_PRODUCTION } from 'constants/Global';

import sagas from './sagas';
import reducer from './reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([sagaMiddleware]),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().prepend(sentryReduxEnhancer),
});

sagaMiddleware
  .run(sagas)
  .toPromise()
  .catch((error) => {
    if (IS_PRODUCTION) {
      Sentry.captureException(error);
    }
  });

if (!IS_PRODUCTION && module.hot) {
  module.hot.accept('./reducers', () => store.replaceReducer(reducer));
}

store.close = () => store.dispatch(END);

export { store };
